"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = void 0;
const react_intl_1 = require("react-intl");
const table_cells_1 = require("../../composite/table/table-cells");
const table_filter_cells_1 = require("../../composite/table/table-filter-cells");
const actions_api_1 = require("./actions-api");
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'scriptType',
            sortkey: 'scriptType.name',
            filterkey: 'scriptType.id',
            name: intl.formatMessage({
                id: 'EAS_ACTIONS_COLUMN_SCRIPT_TYPE',
                defaultMessage: 'Skriptovací jazyk',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(actions_api_1.useScriptTypes),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(actions_api_1.useScriptTypes),
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
//# sourceMappingURL=actions-columns.js.map